<template>
  <div :class="'card-login-cadastro ' + cardStyle">
      <b-modal ref="modalErroCert" size="lg" scrollable title="Login" id="modal-dialog">
          <template v-slot:modal-footer="{ ok, cancel }">
          <b-button size="lg" variant="danger" @click="confirmaleitura('n')" class="mr-auto">Voltar</b-button>
          <b-button size="lg" variant="success" @click="confirmaleitura('s')">Continuar</b-button>
          </template>
          <p> <span v-html="erroCert"></span></p>
      </b-modal>
      <b-modal ref="modalLoading" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
          <p class="my-4">
          <template>
              <div class="d-flex justify-content-center mb-3">
              <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
              </div>
          </template>
          </p>
      </b-modal>
      <b-card tag="article" class="shadow-sm cardLogin" deck>
        <template v-if="stepLogin==1">
          <h4 v-show="!pesquisa" class="card-title blueE">Já sou cadastrado</h4>
          <!-- <b-card-text>Acesse sua conta para utilizar os serviços</b-card-text> -->

          <b-form-group id="fieldset-1">
              <!-- <b-input-group class="mb-2">
              <b-input-group-prepend>
                  <span class="input-group-text">
                  <font-awesome-icon icon="user" />
                  </span>
              </b-input-group-prepend>
              <the-mask :mask="['###.###.###-##', '##.###.###/####-##']" :state="cpf_state" v-model="cpf" placeholder="Seu CPF/CNPJ" class="form-control" /> -->
              <!-- <b-form-input type="text" :state="cpf_state" v-model="cpf" @keydown.native="CPF_Monitor" placeholder="digite somente números" maxlength="14"></b-form-input> -->
              <!-- </b-input-group> -->
              <b-col mb="2">
                <label for="usario">Usuário</label>
                <the-mask id="usario" :mask="['###.###.###-##', '##.###.###/####-##']" :state="cpf_state" v-model="cpf" placeholder="Número CPF/CNPJ" class="form-control" />
              </b-col>
          </b-form-group>

          <b-form-group id="fieldset-2" >
              <!-- <b-input-group class="mb-2">
              <b-input-group-prepend>
                  <span class="input-group-text">
                  <font-awesome-icon icon="lock" />
                  </span>
              </b-input-group-prepend>
              <b-form-input type="password" :state="senha_state" id="senha" v-model="senha" placeholder="Senha"></b-form-input>
            </b-input-group> -->
            <b-col mb="2">
                <label for="senha">Senha</label>
                <b-input-group>
                  <b-form-input :type="(pwdHidden?'password':'text')" :state="senha_state" id="senha" v-model="senha" placeholder="*******"></b-form-input>
                  <font-awesome-icon :class="'hide-pwd ' + (pwdHidden?'':'slash')" :icon="(pwdHidden?'eye':'eye-slash')" @click="pwdHidden = !pwdHidden" />
                </b-input-group>
            </b-col>
          </b-form-group>
          <vue-recaptcha
              ref="invisibleRecaptcha"
              @verify="onVerify"
              @expired="onExpired"
              size="invisible"
              badge="bottom"
              :sitekey="sitekey">
          </vue-recaptcha>
          <!-- <vue-recaptcha
              v-if="challenge"
              ref="challengeRecaptcha"
              @verify="onVerifyV2"
              @expired="onExpiredV2"
              size="visible"
              :sitekey="sitekeyV2">
          </vue-recaptcha> -->
          <br>
          <b-alert variant="danger" class="text-center" :show="falha_login" fade>{{ falha_login_msg }}</b-alert>
          <div  class="manter-logado-container d-flex mb-4" :class="(manterLogado?' selected':'')" v-on:click="switchManterLogado" v-if="!loginSSO">
            <span>Manter-me conectado</span>
            <b-form-checkbox
              class="manter-logado-selection" 
              v-model="manterLogado"
              size="lg"
              switch
            />
          </div>
          <!-- <b-button v-if="loginSSO" ref="btnLogin" variant="primary" class="btn-lg mb-2" block @click="validarLoginSSO()">
              <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner>
              Entrar
          </b-button> -->
          <b-button ref="btnLogin" variant="primary" class="btn-lg mb-2" block @click="validarLogin()" >
              <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner>
              Entrar
          </b-button>
          <div class="text-center mb-2 esqueci-senha-container" v-if="!loginSSO">
            <a class="link" @click="$router.push({ name: 'recuperar-senha' })">Esqueci minha senha</a>
          </div>
          <template v-if="!$root.isDevice">
            <div v-if="loginSSO" class="certificadoDigital text-center cert-sso" @click="certLoginSSO()" style="cursor:pointer">
              
              <img src="~@/assets/imgs/e@-certificado-login.png"><span>Continuar utilizando certificado digital</span>
            </div>
            <div v-else class="certificadoDigital text-center cert" @click="abrirModalSelecao" style="cursor:pointer">
              <img src="~@/assets/imgs/e@-certificado-login.png"><span>Continuar utilizando certificado digital</span>
            </div>
          </template>
          <div class="card-login-alternativo"> 

          <button v-if="!noLoginGov" class="br-sign-in mb-3" type="button" @click="loginGov()" >Entrar com&nbsp;<img src="https://www.gov.br/++theme++padrao_govbr/img/govbr-colorido-b.png" alt="gov.br"/></button>
          <div class="text-center">
          </div>

          </div> 
          <b-col v-if="cadastro || loginSSO" mb="2" class="btn-cadastro-container">
            <span>Ainda não é cadastrado?</span>
            <b-button class="btnCadastro" @click="$router.push({ name: 'cadastro', params: { tipo_cadastro: tipo_login, client_id: $route.query.client_id, redirect_uri:$route.query.redirect_uri} })">Cadastre-se</b-button>
          </b-col>
          <div class="text-center mb-2 politica-privacidade-container">
            <span>Conheça nossa <a class="link" href="../pdf/politica-privacidade_2022-12-19.pdf"  target="_blank">Política de Privacidade</a></span>
          </div>    
        </template>
        <template v-if="stepLogin==2">
          <div class="voltar-step-login" @click="stepLogin--">
            <span>Voltar</span>
          </div>
          <h4 class="card-title blueE">Verifique sua conta</h4>
          <p class="mb-3">Selecione a opção para receber o código de verificação de conta:</p>
          <div id="token-option-selection">
            <div v-for="optionToken in optionTokenList"
              class="card-token-option-selection" 
              @click="tokenOptionSelect = optionToken.value"
            >
              <div class="d-flex justify-content-center p-2" style="width:fit-content;border-radius: 14px;background-color: #4780F130;">
                <img :src="getSVGIcon(optionToken.icon)" :style="'width: 30px;height: 30px;' + optionToken.iconStyle"/>
              </div>
              <div class="d-flex flex-column text-card">
                <h3>{{ optionToken.title }}</h3>
                <span>{{ optionToken.text }}
                  <br>
                  {{ optionTokenText(optionToken.value) }}
                </span>
              </div>
              <input   
                type="radio"
                v-model="tokenOptionSelect"
                :value="optionToken.value"
                class="option-token"
              >
            </div>
          </div>
          <b-button ref="btnLogin" variant="primary" class="btn-lg mb-2 problema-token-btn" block @click="requesitarToken2fa()" :disabled="!tokenOptionSelect">
              <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner>
              ENVIAR CÓDIGO
          </b-button>
          <div class="text-center mb-2 problema-token">
            <a class="link" @click="$router.push({ name: 'recuperar-senha' })">Problemas com o Endereço de E-mail?<br>Entre em Contato com o Suporte.</a>
          </div>
        </template>
        <template v-if="stepLogin==3">
          <div class="voltar-step-login" @click="stepLogin--">
            <span>Voltar</span>
          </div>
          <h4 class="card-title blueE">Verificação em 2 etapas</h4>
          <p>Digite o código de 6 dígitos que enviamos para seu email {{ email }}</p>
          <div :class="'token-login-container' + (falha_login ? ' login-danger':'')">
            <p class="label-token">Insira o código</p>
            <div v-for="(char, index) in token2fa" class="token-login-input-container">
              <input
                :key="index"
                v-model="token2fa[index]"
                @input="handleInput2fa(index, $event)"
                @keydown="handleKeyDown2fa(index, $event)"
                @paste="handlePaste2fa($event)"
                class="token-login-input"
                maxlength="1"
                :ref="`input_2fa_${index}`"
                placeholder="_"
              />
            </div>
            <div class="mb-4">
              <p class="token-error-msg" v-if="falha_login" fade>{{ falha_login_msg }}</p>
              <p v-if="timer2fa.current > 0">Reenviar código em {{formatTimer(timer2fa.current)}}</p>
              <p v-else>
                <a class="link" @click="reenviarToken2fa()">Reenviar código <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner></a>
              </p>
              <p>Se você não recebeu o código em seu email cadastrado dentro de 2 minutos, por favor, atualize e verifique suas informações de contato ou considere verificar sua pasta e spam.</p>
            </div>
            <b-button id="btnConfirmaToken2fa" ref="btnConfirmaToken2fa" class="btnCadastro" @click="confirmaToken2fa()" :disabled="!(token2faString.length == token2fa.length)">
              <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner>
              Confirmar código
            </b-button>
          </div>
        </template>
      </b-card>

      <b-modal ref="modalSelecaoCertificado" title="Selecione seu Certificado" hide-footer centered>
          <div class="d-block text-center">
              <p>Encontramos os seguintes certificados no seu computador:</p>
              
              <div v-if="listaCertificados.length === 0" class="alert alert-warning">
                  Nenhum certificado válido encontrado.
                  <br>
                  <small>Certificados expirados não são exibidos. Verifique se:</small>
                  <ul class="mt-2 mb-0" style="font-size: 0.9em;">
                    <li>O Web PKI está instalado <a href="https://get.webpkiplugin.com/" target="_blank">clique aqui</a></li>
                    <li>Você possui certificados digitais válidos (não expirados)</li>
                    <li>Os certificados estão instalados corretamente</li>
                  </ul>
              </div>

              <select v-else class="form-control mb-4" v-model="certificadoSelecionado">
                  <option :value="null">Selecione...</option>
                  <option v-for="cert in listaCertificados" :key="cert.thumbprint" :value="cert">
                      {{ cert.subjectName }} (Válido até: {{ formatarData(cert.validityEnd) }})
                  </option>
              </select>

              <b-button variant="primary" block @click="certLogin" :disabled="!certificadoSelecionado">
                  <i class="fa fa-check"></i> Confirmar e Entrar
              </b-button>
              
              <b-button variant="link" size="sm" class="mt-2" @click="carregarCertificados">
                  <i class="fa fa-sync"></i> Atualizar Lista
              </b-button>
          </div>
      </b-modal>
  </div>
</template>
<script>
  import { TheMask } from 'vue-the-mask'
  import VueRecaptcha from 'vue-recaptcha'
  import Serv from "../../services"
  import APIConsulta from "../../services/api_consulta"
  import API from "../../services/api"
  import { setTimeout } from "timers"
  import CryptoJSAesJson from "../../services/CryptoJSAesJson";

  export default {
  components: {
    VueRecaptcha,
    TheMask
  },
  props: {
    cardStyle: '',
    loginSSO: Boolean,
    clientId: String,
    noLoginGov: Boolean,
    cadastro: Boolean,
    pesquisa: Boolean,
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
      // sitekeyV2: process.env.VUE_APP_sitekeyRecaptcha,
      erroCert: "",
      loading: false,
      cpf_state: null,
      cpf: "",
      tok: "",
      // challengeTok: "",
      // challenge: false,
      senha_state: null,
      senha: "",
      falha_login: false,
      falha_login_msg: '',
      okclicked: false,
      loginComCertificado: false,
      pwdHidden: true,
      stepLogin: 1,
      token2fa: Array(6).fill(""),
      timer2fa:{current:0,value:120},
      email: '',
      telefone: '',
      wpp: '',
      optionTokenList:[        
        {title:'Valide por E-mail',icon:'envelope_icon',iconStyle:'',text:'Enviar código via e-mail para ', value:'email'},
        // {title:'Valide por SMS',icon:'sms_icon',iconStyle:'margin-left: 3px;margin-right: -3px;',text:'Enviar código via SMS para o telefone terminado em ',value:'sms'},
        // {title:'Valide por WhatsApp',icon:'whatsapp_logo',iconStyle:'',text:'Enviar código via WhatsApp para o telefone terminado em ',value:'wpp'}
        // {title:'Valide por WhatsApp',icon:'@/assets/imgs/svg/whatsapp_logo.svg',text:'Enviar código via WhatsApp para o telefone terminado em',value:'wpp'}
      ],
      tokenOptionSelect:false,
      manterLogado:false,
      pki: null,
      listaCertificados: [],
      certificadoSelecionado: null,
      erroCertificadoDigital: false
    };
  },

  mounted() {
      this.carregarWebPKI();
  },
  methods: {
    getSVGIcon(icon) {
      var images = require.context('../../assets/imgs/svg/', false, /\.svg$/)
      return images('./' + icon + ".svg")
    },
    // onVerifyV2: function (response) {
    //   this.challengeTok = response
    //   if(response != '') this.login(this.challengeTok);
    //   this.resetRecaptchaV2()
    // },
    // resetRecaptchaV2: function () {
    //   this.$refs.challengeRecaptcha.reset();
    //   this.challengeTok = '';
    // },
    // onExpiredV2: function () {
    //   this.resetRecaptchaV2();
    // },
    onVerify: function (response) {
      this.tok = response
      if(response != '') this.login(this.tok);
      this.resetRecaptcha()
    },
    onExpired: function () {
      this.resetRecaptcha();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset();
      this.tok = '';
    },
    validarLogin() {
      if(this.stepLogin == 1){
        // if (this.challenge) {
        //   this.resetRecaptchaV2();
        //   this.$refs.challengeRecaptcha.execute();
        // } else {
        //   this.resetRecaptcha();
        //   this.$refs.invisibleRecaptcha.execute();
        // }
        this.resetRecaptcha();
        this.$refs.invisibleRecaptcha.execute();
      }
      else this.login();
    },
    login(tok){
      this.pwdHidden = true;
      if (this.cpf.length > 0 && this.senha.length > 0) {
        this.$root.clearLocalStorage();
        if (!this.okclicked) {
          if(this.$root.isDevice)
          {
            this.confirmaleitura('s')
          }
          else{
            this.erroCertificadoDigital = false; // Reset da flag para erros que não são de certificado
            this.erroCert = 'Para realizar envio de títulos a protesto ou emitir carta de anuência eletrônica, é necessário realizar o login por meio de Certificado Digital ICP-Brasil ou login por meio de seu acesso .GOV.BR '
            this.$refs['modalErroCert'].show();
          }
        }
        if (this.okclicked) {
          localStorage.setItem("libProcuracao", 'false');
          localStorage.setItem("libAnuencia", 'false');
          // localStorage.setItem("instrumento_protesto_cancelamento", 'true');
          this.loading = true
          this.falha_login = false
          let cpf = this.validar()
          let senha = this.senha
          if (cpf) {
            if (senha != '') {
              this.cpf = cpf;
              
              this.loading = true;
              this.$root.login(this.cpf, this.senha, tok).then((res) => {
                if(res.token != undefined && res.token != '' && res.ic_logado_hoje === 1){
                  localStorage.setItem("jwtToken", res.token)
                  sessionStorage.setItem("jwtToken", res.token)
                  localStorage.setItem("usrName", res.name)
                  localStorage.setItem("usrEmail", res.email)
                  localStorage.setItem("usrCpf", res.cpf)
                  this.email = res.email;
                  if (this.tipo_login === "solicitarCertidao") this.$router.push({ name: "emolumentos" });
                  else if(this.pesquisa){
                    this.$refs['modalErroCert'].hide();
                    this.$emit('loginpesquisa', {resposta:true});
                  }
                  else{
                    if(res.ic_atualizacao_termo != 1){
                      this.$router.push('/termo-aceite-site')
                    } else {
                      this.$router.push({ name: "painel" });
                    }
                  }
                  // window.location.reload()

                  this.loading = false
                }
                else{
                  localStorage.setItem("usrName", res.name)
                  localStorage.setItem("usrEmail", res.email)
                  localStorage.setItem("usrCpf", res.cpf)
                  this.email = res.email;
                  this.telefone = res.telefone;
                  this.wpp = res.wpp;
                  this.loading = false;
                  this.stepLogin = 2;
                  this.timer2fa.current = this.timer2fa.value;

                  this.loading = false
                }
              }).catch((res) => {
                this.loading = false;
                this.resetRecaptcha();
                switch (res.error) {
                  case 1:
                    this.falha_login_msg = 'CPF não encontrado.';
                    break;
                  case 5:
                    if(res.error.message != undefined && res.error.message != null && res.error.message != ''){
                      this.falha_login_msg = res.error.message;
                    }
                    else this.falha_login_msg = `Erro ao processar login.`;
                    // this.challenge = true;
                    break;
                  default:
                    this.falha_login_msg = 'Senha inválida.';
                    break;
                }
                this.falha_login = true;
                this.loading = false;
              })
            }
          } else {
            alert('Usuário ou senha inválido')
            this.loading = false
          }
        }
      } else {
        this.$refs['modalErroCert'].hide();
      }
    },
    validar() {
      let cpf = this.cpf.replace(/\./g, "").replace("-", "");
      let cpf_valido = null;

      if (this.cpf.length === 14) 
        cpf_valido = Serv.validarCNPJ(cpf) ? null : false;
      else 
        cpf_valido = Serv.validarCPF(cpf) ? null : false;

      this.cpf_state = !this.cpf ? false : cpf_valido !== false ? null : false;
      this.senha_state = !this.senha ? false : null;
      if (this.cpf && this.senha && cpf_valido === null) 
        return cpf;
    },
    mascaraCPF(event) {
      var ao_cpf = event.target.value;
      var cpfValido = /^(([0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}))$/;
      if (cpfValido.test(ao_cpf) == false) {
        ao_cpf = ao_cpf.replace(/\D/g, ""); //Remove tudo o que não é dígito
        if (ao_cpf.length == 11) {
          ao_cpf = ao_cpf.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
          ao_cpf = ao_cpf.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          ao_cpf = ao_cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
          event.target.value = ao_cpf;
          document.getElementById("senha").focus();
        }
      }
    },
    CPF_Monitor(event) {
      if (
        (event.which >= 48 && event.which <= 57) ||
        (event.which >= 96 && event.which <= 105) ||
        (event.which == 8 ||
          event.which == 46 ||
          event.which == 37 ||
          event.which == 39)
      )
        setTimeout(() => {
          this.mascaraCPF(event);
        }, 10);
      else {
        event.preventDefault();
      }
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
    async certLogin() {
      this.loginComCertificado = true
      this.cpf = null
      this.senha = null
      // if (this.cpf.length == 0 && this.senha.length == 0) {
        this.$refs['modalLoading'].show();
        const res = await APIConsulta.get(`pki/login/cenprotPublico`).catch(() => {
          this.erroCertificadoDigital = true; // Marcar que o erro é do certificado digital
          this.erroCert  = "<h5><b><font color='red'>Antes de realizar o login no site. <a href='cadastro'>Clique aqui e faça seu cadastro</a></font></b></h5>";
          this.erroCert += "<hr><b>Erro ao acessar com o Certificado Digital</b>";
          this.erroCert += "<br>Siga os passos para a correção:<br>";
          this.erroCert += "<b class='ml-3'>• Limpeza de cache do navegador:</b>";
          this.erroCert += "<p class='ml-4'>Após esse procedimento, deve-se fechar <font color='red'>todas</font> as abas do navegador e acessar o site novamente.</p>";
          this.erroCert += "<p class='ml-4'>Para limpeza total do cache, deve-se utilizar o comando <b>CTRL + SHIFT + DEL</b>, após isso deve-se selecionar em <b>“Período” -> Todo período</b> e marcar <b>TODOS</b> os quadrados. Depois clique no botão “limpar dados”, aguarde a janela se fechar e abra o navegador novamente.</p>";
          this.erroCert += "<b class='ml-3'>• Remover certificado(s) vencido(s):</b>";
          this.erroCert += "<p class='ml-4'>Acesse o Painel de Controle -> Rede e Internet -> Opções da Internet. Será aberta uma nova janela. Selecione a aba <b>Conteúdo</b> e depois <b>Certificados</b>.<br>Será possível ver se o seu certificado está vencido ou não. Caso tenha algum certificado vencido, o mesmo deve ser removido.</p>";
          this.erroCert += "<b class='ml-3'>• Antivírus:</b>";
          this.erroCert += "<p class='ml-4'>Alguns antivírus negam o acesso à sites com a utilização do certificado digital e da cadeia de certificação. Antivírus como o <b>Kaspersky, McAfee</b> e <b>Avast</b> podem bloquear o acesso ao site com certificado digital. Neste caso, é necessário acionar sua equipe de suporte para configurá-lo corretamente.</p>";
          this.erroCert += "<b class='ml-3'>• Bloqueio de IP ou Proxy:</b>";
          this.erroCert += "<p class='ml-4'>Algumas redes empresariais possuem bloqueio de IP para acesso a determinados sites. Consulte o <b>TI</b> da sua empresa para verificar se há bloqueio e realizar, se necessário, o desbloqueio do site da Cenprot pelo IP.</p>";
          this.erroCert += "<b class='ml-3'>• Verificação da Cadeia de Certificação ICP-Brasil:</b>";
          this.erroCert += "<p class='ml-4'>É de extrema importância que essa verificação seja feita, pois o site da Cenprot utiliza essa cadeia para acesso com certificado digital.</p>";
          this.erroCert += "<p class='ml-4'>Como fazer essa verificação:<br>Acesse o Painel de Controle -> Rede e Internet -> Opções da Internet. Na janela que abrir, vá até a aba <b>Conteúdo</b> e clique em <b>Certificados</b>. Localize o certificado que será usado no acesso ao site da Cenprot, dê dois cliques com o botão esquerdo e vá até a aba <b>“Caminho de Certificação”</b>. <font color='red'>DEVE</font> conter toda a cadeia de certificação desde a ICP-Brasil até o seu certificado. Feito isso, feche tudo e acesse novamente o site.</p>";
          this.erroCert += "<b class='ml-3'>• Atenção:</b>";
          this.erroCert += "<p class='ml-4'>Se houver qualquer mensagem em <b>“Caminho de Certificação”</b> diferente de <b><font color='red'>“ESSE CERTIFICADO É VÁLIDO”</font></b>, entre em contato com o responsável técnico da sua empresa ou com a certificadora do seu certificado.</p>";
          this.erroCert += "<p class='ml-4'>Recomendamos também a utilização do navegador <b>Google Chrome</b> pela sua maior compatibilidade com certificado digital. Caso tenha seguido todos os passos e ainda assim não consiga acessar, entre em contato pelo telefone <b>(11) 3112-0698</b>.</p>";

          this.$refs['modalErroCert'].show();
          this.$refs['modalLoading'].hide();
        })
        if (res != null )
        {
          if(res.data.ic_autenticado > 0) {
            if (res.data.sg_tipo_documento == "CNPJ") {
              localStorage.setItem("libProcuracao", 'true');
            }
            else {
              localStorage.setItem("libProcuracao", 'false');
            }
            localStorage.setItem("libAnuencia", 'true');

            localStorage.setItem("nm_thumbprint", res.data.nm_thumbprint)
            localStorage.setItem("nm_thumbprint_sha256", res.data.nm_thumbprint_sha256)
            localStorage.setItem("sg_tipo_documento", res.data.sg_tipo_documento)
            localStorage.setItem("nm_nr_documento_cert", res.data.nm_nr_documento)
            localStorage.setItem("SSL_CLIENT_S_DN_CN", res.data.SSL_CLIENT_S_DN_CN)
            localStorage.setItem("nm_tipo_certificado", res.data.nm_tipo_certificado)
            localStorage.setItem("SSL_CLIENT_S_DN", res.data.SSL_CLIENT_S_DN)
            localStorage.setItem("SSL_CLIENT_V_START", res.data.SSL_CLIENT_V_START)
            localStorage.setItem("SSL_CLIENT_V_END", res.data.SSL_CLIENT_V_END)





      
            let password = process.env.VUE_APP_CHAVE_CRIPTOGRAFIA.toString();
            let encrypted = CryptoJSAesJson.encrypt(res.data.nm_nr_documento, password);
            let encryptedUrl = btoa(encrypted);
            const resLogin = await API.post(`auth/login/cert`, { cpf: encryptedUrl })

            // console.log(resLogin.data)
            // let encryptedRes = JSON.stringify(resLogin.data);
            // console.log(encryptedRes)
            // let decrypted = JSON.parse(CryptoJSAesJson.decrypt(encryptedRes, password));
            // console.log(decrypted)

            // resLogin.data = encryptedRes;

            localStorage.setItem("jwtToken", resLogin.data.token)
            localStorage.setItem("tokenTermo", resLogin.data.tokenTermo)
            sessionStorage.setItem("jwtToken", resLogin.data.token)
            localStorage.setItem("usrName", resLogin.data.name)
            localStorage.setItem("usrEmail", resLogin.data.email)
            localStorage.setItem("usrCpf", resLogin.data.cpf)

            this.$refs['modalLoading'].hide();
            if (this.tipo_login === "solicitarCertidao") {
              this.$router.push({ name: "emolumentos" })
            } else if(this.pesquisa){
              this.$emit('loginpesquisa', {resposta:true});
            }
            else{
              if(resLogin.data.ic_atualizacao_termo != 1) this.$router.push('/termo-aceite-site')
              else this.$router.push({ name: "painel" });
            }
          }
          else {
            //this.$router.push({ name: "painel" })
            this.$refs['modalLoading'].hide();
            this.erroCertificadoDigital = true; // Marcar que o erro é do certificado digital
            this.erroCert = "Usuário do certificado não cadastrado"
            this.$refs['modalErroCert'].show();
          }
       }
    },
    async loginGov() {
      // window.location.href = "https://sso.staging.acesso.gov.br/authorize?response_type=code&client_id=site-homolog.cenprotnacional.org.br&redirect_uri=https%3A%2F%2Fsite-homolog.cenprotnacional.org.br&scope=openid+email+profile+govbr_confiabilidades&code_challenge=LsKeMhlaDIbQUUiY0KYVJE4TKUAMgx7Tn9fvTgSzP0Q&code_challenge_method=S256";
      window.location.href = "https://sso.acesso.gov.br/authorize?response_type=code&client_id=site.cenprotnacional.org.br&redirect_uri=https%3A%2F%2Fsite.cenprotnacional.org.br&scope=openid+email+profile+govbr_confiabilidades&code_challenge=9G_QBWT_tlmc4hrorsy_A_gREHppo74Oyrn8w45W0bM&code_challenge_method=S256";
    },
    confirmaleitura(confirma) {
      if (this.loginComCertificado) {
        this.cpf = ''
        this.senha = ''
      }
      if (confirma == 's') {
        // Se o erro foi do certificado digital, não fazer login normal
        if (this.erroCertificadoDigital) {
          this.erroCertificadoDigital = false; // Reset da flag
          this.$refs['modalErroCert'].hide();
          return; // Não fazer login
        }
        
        this.okclicked = true;
        if(this.loginSSO) this.validarLoginSSO();
        else this.validarLogin();
        
        this.$refs['modalErroCert'].hide();
      }
      else {
        this.erroCertificadoDigital = false; // Reset da flag quando clicar em Voltar
        this.$refs['modalErroCert'].hide();
      }
    },
    handleInput2fa(index, event) {
      if (event.target.value.match(/[0-9a-zA-Z]/)) {
        this.falha_login = false
        this.$set(this.token2fa, index, event.target.value);
        if (index < this.token2fa.length - 1) {
          this.$refs[`input_2fa_${index + 1}`][0].focus();
        }
      } else {
        this.$set(this.token2fa, index, "");
      }
    },
    handleKeyDown2fa(index, event) {
      if (event.key === "ArrowRight" && index < this.token2fa.length - 1) {
        this.$refs[`input_2fa_${index + 1}`][0].focus();
      } else if (event.key === "ArrowLeft" && index > 0) {
        this.$refs[`input_2fa_${index - 1}`][0].focus();
      } else if (event.key === "Tab") {
        event.preventDefault();
        if (event.shiftKey) {
          if (index > 0) {
            this.$refs[`input_2fa_${index - 1}`][0].focus();
          }
        } else {
          if (index < 7) {
            this.$refs[`input_2fa_${index + 1}`][0].focus();
          }
        }
      } else if (event.key === "Backspace" || event.key === "Delete") {
        event.preventDefault();
        this.falha_login = false
        this.$set(this.token2fa, index, "");
        if (index > 0) {
          this.$refs[`input_2fa_${index - 1}`][0].focus();
        }
      } else if(event.key.match(/[0-9a-zA-Z]/) && event.key.length === 1 && !event.ctrlKey){
        if(this.token2fa[index] !== '') {
          this.falha_login = false
          this.$set(this.token2fa, index, event.key);
          event.preventDefault();
          this.$refs[`input_2fa_${index + 1}`][0].focus();
        }
      }
    },
    handlePaste2fa(event) {
      event.preventDefault();
      this.falha_login = false
      let pastedData = event.clipboardData.getData("text/plain");
      let pastedCharacters = pastedData.split("");
      let inputIndex = 0;
      pastedCharacters.forEach((char, index) => {
        if(char.match(/[0-9a-zA-Z]/) && inputIndex < this.token2fa.length){
          this.$set(this.token2fa, inputIndex, char);
          inputIndex++;
        }
      });
      if(inputIndex < this.token2fa.length){
        this.$refs[`input_2fa_${inputIndex}`][0].focus();
      }
      else{
        this.$nextTick(() => {
          this.$refs.btnConfirmaToken2fa.focus();
        });
      }

    },
    requesitarToken2fa(){
      this.reenviarToken2fa();
      this.stepLogin++;
    },
    confirmaToken2fa(){
      this.loading = true;
      API.post("/auth/validateToken2fa", { cpf: this.cpf, token2fa: this.token2faString}).then((res) => {
        let response = res.data

        localStorage.setItem("jwtToken", response.token)
        localStorage.setItem("tokenTermo", response.tokenTermo)
        sessionStorage.setItem("jwtToken", response.token)
        localStorage.setItem("usrName", response.name)
        localStorage.setItem("usrEmail", response.email)
        localStorage.setItem("usrCpf", response.cpf)

        this.loading = false
        if (this.tipo_login === "solicitarCertidao") {
          this.$router.push({ name: "emolumentos" })
        } else if(this.pesquisa){
          this.$refs['modalErroCert'].hide();
          this.$emit('loginpesquisa', {resposta:true});
        }
        else{
          this.$router.push({ name: "painel" }).catch(() => {});
        }

      }).catch((error) => {
        let res = error.response.data
        if (res.error === 1)
          this.falha_login_msg = 'CPF não encontrado.'
        else if (res.error === 3)
          this.falha_login_msg = 'Token inválido.';
        else
          this.falha_login_msg = 'token inválido.'
        this.falha_login = true
        this.loading = false
        this.resetRecaptcha()
      });
    },
    reenviarToken2fa(){
      this.loading = true;
      this.falha_login = false

      API.post("/auth/gerarToken2faLogin", {cpf: this.cpf, token2faOpcao: this.tokenOptionSelect}).then((res) => {
        this.timer2fa.current = this.timer2fa.value;
        this.token2fa = Array(6).fill("");
        
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
      });
    },
    formatTimer(time){
      return new Date(time * 1000).toISOString().substring(14, 19)
    },
    optionTokenText(option){
      let text = '';
      switch (option) {
        case 'email': text = this.email; break;
        case 'sms': text = this.telefone; break;
        case 'wpp': text = this.wpp; break;
      }
      return text;
    },
    switchManterLogado(){
      this.manterLogado = !this.manterLogado;
      event.preventDefault();
    },
    validarLoginSSO() {
      this.pwdHidden = true;
      if (this.cpf.length > 0 && this.senha.length > 0) {
        this.$root.clearLocalStorage();
        if (!this.okclicked) {
          if(this.$root.isDevice) { this.confirmaleitura('s') }
          else{
            this.erroCertificadoDigital = false; // Reset da flag para erros que não são de certificado
            this.erroCert = 'Para realizar envio de títulos a protesto ou emitir carta de anuência eletrônica, é necessário realizar o login por meio de Certificado Digital ICP-Brasil ou login por meio de seu acesso .GOV.BR '
            this.$refs['modalErroCert'].show();
          }
        }
        if (this.okclicked) {
          this.loading = true
          this.falha_login = false
          let cpf = this.validar()
          let senha = this.senha
          if (cpf) {
            if (senha != '') {
              this.cpf = cpf;
              this.loading = true;
              this.$root.loginSSO(this.cpf, this.senha, this.tok, this.clientId).then((res) => {
                if(res.access_token != undefined && res.access_token != ''){
                  this.$emit('loginSSOResponse', {resposta:true,access_token:res.access_token});
                }
              }).catch((res) => {
                this.loading = false;
                if (res.error === 1)
                  this.falha_login_msg = 'CPF não encontrado.'
                else
                  this.falha_login_msg = 'Senha inválida.';
                this.falha_login = true;
                this.loading = false;
              })
            }
          } else {
            alert('Usuário ou senha inválido')
            this.loading = false
          }
        }
      } else {
        this.$refs['modalErroCert'].hide();
      }
    },
    async certLoginSSO() {
      this.loginComCertificado = true
      this.cpf = null
      this.senha = null
      // if (this.cpf.length == 0 && this.senha.length == 0) {
        this.$refs['modalLoading'].show();
        const res = await APIConsulta.get(`pki/login/cenprotPublico`).catch(() => {
          this.erroCertificadoDigital = true; // Marcar que o erro é do certificado digital
          this.erroCert = "<h5><b><font color='red'>Antes de realizar o login no site. <a href='cadastro'>Clique aqui e faça seu cadastro</a></font></b></h5>"
          this.erroCert += "<hr><b>Erro ao acessar com o Certificado Digital</b>"
          this.erroCert += "<br>Siga os passos para a correção: <br>"
          this.erroCert += "<b class='ml-3'>•	Limpeza de cache do navegador</b>:"
          this.erroCert += "<p class='ml-4'> Após esse procedimento, deve-se fechar <font color='red'>todas</font> as abas do navegador e acessar o site novamente.</p>"
          this.erroCert += "<p class='ml-4'>Para limpeza total do cache, deve-se utilizar o comando <b>CTRL + SHIFT + DEL</b>, após isso deve se selecionar em <b>“Período” - > Todo período</b> e marcar <b>TODOS</b> os quadrados, depois clicar no botão “limpar dados”, e deve-se aguardar o que a janela se feche e depois abrir o navegador de novo.</p>"
          this.erroCert += " <b class='ml-3'>•	Remover certificado(s) vencido(s):</b> <p class='ml-4'> Para isso, acesse o Painel de Controle -> Rede e Internet -> Opções da Internet,com isso será aberta uma nova janela, selecione a aba <b>Conteúdo</b> e depois <b>Certificados.</b> <br>Será possível ver se o seu certificado está vencido ou não.<br>Caso tenha algum certificado vencido, o mesmo deve ser removido.</p>"
          this.erroCert += "<b class='ml-3'>•	Antivírus:</b><p class='ml-4'>Alguns antivírus negam o acesso á sites com a utilização do certificado digital, e toda a cadeia de certificação. Neste caso, é necessário inativá-lo para que possa acessar o site com seu certificado digital.</p><p class='ml-4'>Antivírus como o <b>Kaspersky, FortClient</b> e <b>Avast</b>, podem bloquear o acesso ao site, por não estarem configurados para isso, pedimos que inativem o mesmo para acesso ao site.</p>"
          this.erroCert += "<b class='ml-3'>•	Bloqueio de IP ou Proxy:</b><p class='ml-4'>Algumas redes de internet empresárias possuem bloqueio de IP para acesso á alguns sites, por isso deve consultar o <b>TI</b> da sua empresa para que faça, <b>se tiver</b>, o desbloqueio do site através do IP do site da Cenprot.</p>"
          this.erroCert += " <b class='ml-3'>•	Verificação da Cadeia de Certificação ICP-Brasil:</b> <br> <p class='ml-4'>É de extrema importância que seja feito essa verificação, devido ao fato de que o Site da Cenprot utiliza dessa cadeia de certificação para acesso ao site.</p><br>"
          this.erroCert += " <p class='ml-4'>Como fazer essa verificação: <br> Acesse o Painel de Controle -> Rede e Internet -> Opções da Internet, com isso será aberta uma nova janela, selecione a aba <b>Conteúdo</b> e depois <b>Certificados</b>, com isso será listado o(s) certificado(s) presentes na sua maquina, com isso localize aquele que irá acessar o Site da Cenprot, de dois cliques com o botão esquerdo, ele irá abrir uma tela com os dados do certificado, com isso vá em <b>“Caminho de Certificação”</b>, e <font color='red'>DEVE</font> conter toda a cadeia de certificação, desde a ICP-Brasil até o seu. Feito isso, é só fechar tudo e acessar o site.</p>"
          this.erroCert += " <b class='ml-3'>•	Atenção:</b> <br> <p class='ml-4'>Qualquer mensagem que apresente em <b>“Caminho de Certificação”</b>, em toda a cadeia, que seja <b><font color='red'>DIFERENTE</font></b> de “ESSE CERTIFICADO É VÁLIDO”, você deve entrar em contato com o responsável sobre isso da sua empresa ou a empresa certificadora do <font color='red'>SEU</font> certificado.</p><br>"
          this.erroCert += " <p class='ml-4'> Recomendamos também a utilização somente do navegador Google Chrome, devido a sua facilidade em questão do certificado digital. Caso você tenha seguido os passos e mesmo assim ainda não conseguiu acessar, entrar em contato através do (11) 3112-0698.</p>";

          this.$refs['modalErroCert'].show();
          this.$refs['modalLoading'].hide();
        })
        if (res != null )
        {
          if(res.data.ic_autenticado > 0) {
            
            let password = process.env.VUE_APP_CHAVE_CRIPTOGRAFIA.toString();
            let encrypted = CryptoJSAesJson.encrypt(res.data.nm_nr_documento, password);
            let encryptedUrl = btoa(encrypted);
            let client_id = this.clientId ;

            API.post(`auth/login/cert-sso`, { cpf: encryptedUrl, client_id: client_id}).then((resLogin) => {
              let certificado = {
                nm_nr_documento: res.data.nm_nr_documento,
                SSL_CLIENT_S_DN_CN: res.data.SSL_CLIENT_S_DN_CN,
                SSL_CLIENT_S_DN: res.data.SSL_CLIENT_S_DN,
                SSL_CLIENT_V_START: res.data.SSL_CLIENT_V_START,
                SSL_CLIENT_V_END: res.data.SSL_CLIENT_V_END,
                dadosUsuario: resLogin.data.ssl_data
              };
              certificado = btoa(JSON.stringify(certificado));
              this.$emit('certLoginSSOResponse', {resposta:true,access_token:resLogin.data.access_token, ssl_token: certificado});
            }).catch((error) => {
              console.log(error)
            });
          }
          else {
            this.$refs['modalLoading'].hide();
            this.erroCertificadoDigital = true; // Marcar que o erro é do certificado digital
            this.erroCert = "Usuário do certificado não cadastrado"
            this.$refs['modalErroCert'].show();
          }
       }
    },
    
    // 1. Carrega e inicializa WebPKI
    async carregarWebPKI() {
        try {
            // Importa WebPKI dinamicamente
            const { LacunaWebPKI } = await import('web-pki');
            this.pki = new LacunaWebPKI();
            
            // Inicializar
            await new Promise((resolve, reject) => {
                this.pki.init({
                    ready: resolve,
                    notInstalled: () => reject(new Error('WebPKI não instalado')),
                    restPkiUrl: 'https://pki.rest/'
                });
            });
            
            // Após inicializar, carregar lista de certificados
            this.carregarCertificados();
        } catch (error) {
            console.error('Erro ao carregar WebPKI:', error);
            if (error.message.includes('não instalado')) {
                this.$bvToast.toast('WebPKI não instalado. Clique no link no modal para instalá-lo.', { variant: 'warning' });
            } else {
                this.$bvToast.toast('Erro ao iniciar componente de certificação.', { variant: 'danger' });
            }
        }
    },

    // 2. Busca os certificados no navegador do usuário
    carregarCertificados() {
        if (!this.pki) return;
        
        this.pki.listCertificates({
            selectId: null, // Não vamos usar select automático, vamos preencher manual
            filter: this.pki.filters.isPkiBrazilCpf // Opcional: filtrar só e-CPF/CNPJ
        }).success((certs) => {
            // Filtrar apenas certificados válidos (não expirados)
            const certificadosValidos = certs.filter(cert => {
                if (!cert.validityEnd) return true; // Se não tem data de expiração, considera válido
                
                // Converter a data de validade para Date object
                const dataExpiracao = new Date(cert.validityEnd);
                const agora = new Date();
                
                // Retorna true se o certificado ainda está válido
                return dataExpiracao > agora;
            });
            
            
            this.listaCertificados = certificadosValidos;
            // Se tiver apenas 1 certificado válido, já deixa selecionado pra facilitar
            if (certificadosValidos.length > 0) {
                this.certificadoSelecionado = certificadosValidos[0];
            }
        }).fail((error) => {
            console.error('Erro ao carregar certificados:', error);
            this.listaCertificados = [];
        });
    },

    // Método para formatar data em formato brasileiro
    formatarData(dataISO) {
        if (!dataISO) return 'Data inválida';
        try {
            const data = new Date(dataISO);
            return data.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (error) {
            return 'Data inválida';
        }
    },
    
    // 3. Botão da sua imagem chama esta função:
    abrirModalSelecao() {
        // Se a lista estiver vazia, tenta carregar de novo
        if (this.listaCertificados.length === 0) {
            this.carregarCertificados();
        }
        // Abre o modal para o usuário escolher
        this.$refs['modalSelecaoCertificado'].show();
    },

    async certLogin() {
        if (!this.certificadoSelecionado) return;
        
        this.loginComCertificado = true;
        this.cpf = null;
        this.senha = null;
        
        this.$refs['modalSelecaoCertificado'].hide();
        this.$refs['modalLoading'].show();

        try {
            // --- PASSO 1: Obter Nonce ---
            const startResponse = await API.post('auth/cert/start');
            const { token, nonce, digestAlgorithm } = startResponse.data;

            // --- PASSO 2: Assinar ---
            const signature = await new Promise((resolve, reject) => {
                this.pki.signHash({
                    thumbprint: this.certificadoSelecionado.thumbprint,
                    hash: nonce,
                    digestAlgorithm: digestAlgorithm
                })
                .success((signatureString) => resolve(signatureString))
                .fail((error) => reject(new Error(error.message)));
            });

            // --- PASSO 3: Ler Certificado (Para enviar o binário se necessário) ---
            const certificadoBase64 = await new Promise((resolve, reject) => {
                this.pki.readCertificate(this.certificadoSelecionado.thumbprint)
                    .success((c) => resolve(c))
                    .fail((e) => reject(new Error(e.message)));
            });

            // --- PASSO 4: Enviar para o Backend Validar ---
            const resLogin = await API.post('auth/cert/complete', {
                token: token,
                signature: signature,
                certificate: certificadoBase64
            });

            // Se chegou aqui, é sucesso (200 OK). Vamos processar as regras antigas.
            const data = resLogin.data;

            // Salvar apenas as variáveis essenciais (igual à master)
            localStorage.setItem("jwtToken", data.token)
            localStorage.setItem("tokenTermo", data.tokenTermo)
            sessionStorage.setItem("jwtToken", data.token)
            localStorage.setItem("usrName", data.name)
            localStorage.setItem("usrEmail", data.email)
            localStorage.setItem("usrCpf", data.cpf)

            // Regra de Procuração / CNPJ
            if (data.sg_tipo_documento === "CNPJ") {
                localStorage.setItem("libProcuracao", 'true');
            } else {
                localStorage.setItem("libProcuracao", 'false');
            }
            localStorage.setItem("libAnuencia", 'true');

            // Salva dados do certificado (Do Backend ou do JS local)
            localStorage.setItem("nm_thumbprint", this.certificadoSelecionado.thumbprint);
            
            // ATENÇÃO: O backend novo precisa retornar esses campos para você salvar igual antes.
            // Se o backend não retornar, salvamos o que temos disponível.
            if(data.nm_thumbprint_sha256) localStorage.setItem("nm_thumbprint_sha256", data.nm_thumbprint_sha256);
            if(data.sg_tipo_documento) localStorage.setItem("sg_tipo_documento", data.sg_tipo_documento);
            if(data.nm_nr_documento) localStorage.setItem("nm_nr_documento_cert", data.nm_nr_documento);
            
            // Campos legados do Apache/IIS (Salva só se o backend novo enviar)
            if(data.SSL_CLIENT_S_DN_CN) localStorage.setItem("SSL_CLIENT_S_DN_CN", data.SSL_CLIENT_S_DN_CN);
            if(data.nm_tipo_certificado) localStorage.setItem("nm_tipo_certificado", data.nm_tipo_certificado);
            if(data.SSL_CLIENT_S_DN) localStorage.setItem("SSL_CLIENT_S_DN", data.SSL_CLIENT_S_DN);
            if(data.SSL_CLIENT_V_START) localStorage.setItem("SSL_CLIENT_V_START", data.SSL_CLIENT_V_START);
            if(data.SSL_CLIENT_V_END) localStorage.setItem("SSL_CLIENT_V_END", data.SSL_CLIENT_V_END);

            // Sucesso! Redirecionar usando a mesma lógica do login normal
            this.$refs['modalLoading'].hide();
            
            if (this.tipo_login === "solicitarCertidao") {
                console.log('Certificate login: Redirecting to emolumentos'); // Debug log
                this.$router.push({ name: "emolumentos" });
            } else if(this.pesquisa){
                console.log('Certificate login: Emitting loginpesquisa'); // Debug log
                this.$emit('loginpesquisa', {resposta:true});
            } else {
                if(data.ic_atualizacao_termo != 1) {
                    console.log('Certificate login: Redirecting to termo-aceite-site'); // Debug log
                    this.$router.push('/termo-aceite-site');
                } else {
                    console.log('Certificate login: Redirecting to painel'); // Debug log
                    this.$router.push({ name: "painel" });
                }
            }

        } catch (error) {
            this.$refs['modalLoading'].hide();
            console.error('Erro no login com certificado:', error);
            
            // Mostrar erro amigável
            if (error.response && error.response.status === 400) {
                this.erroCertificadoDigital = true;
                this.erroCert = "Usuário do certificado não cadastrado";
                this.$refs['modalErroCert'].show();
            } else {
                this.$bvToast.toast('Erro ao fazer login com certificado: ' + error.message, { variant: 'danger' });
            }
        }
    },
    
    async fazerLoginRestPKI() {
      this.loading = true;
      this.$refs['modalLoading'].show();
      
      try {
        // Carregar e inicializar WebPKI dinamicamente
        await this.carregarWebPKI();
        
        // Aguardar a inicialização do PKI
        await this.inicializarPKI();

        // Listar certificados
        const certificates = await new Promise((resolve, reject) => {
          this.pki.listCertificates({
            selectId: '',
            filter: this.pki.filters.pkiBrazil
          })
          .success((certs) => resolve(certs))
          .fail((error) => reject(new Error("Erro ao listar certificados: " + error.message)));
        });

        if (!certificates || certificates.length === 0) {
          throw new Error('Nenhum certificado digital encontrado.');
        }

        // Para simplicidade, usar o primeiro certificado válido
        const certificado = certificates[0];

        // --- PASSO 1: Start ---
        const startResponse = await API.post('auth/cert/start');
        const { token, nonce, digestAlgorithm } = startResponse.data;

        // --- PASSO 2: Assinatura (Client-side) ---
        const signature = await new Promise((resolve, reject) => {
          this.pki.signHash({
            thumbprint: certificado.thumbprint,
            hash: nonce,
            digestAlgorithm: digestAlgorithm
          })
          .success((signatureString) => resolve(signatureString))
          .fail((error) => reject(new Error("Erro ao assinar: " + error.message)));
        });

        const certificadoBase64 = await new Promise((resolve, reject) => {
          this.pki.readCertificate(certificado.thumbprint)
            .success((content) => resolve(content))
            .fail((ex) => reject(new Error("Erro ao ler certificado: " + ex.message)));
        });

        // --- PASSO 3: Complete (Envio ao Backend) ---
        const completeResponse = await API.post('auth/cert/complete', {
          token: token,
          signature: signature,
          certificate: certificadoBase64
        });

        const responseData = completeResponse.data;

        // Salvar dados na sessão
        localStorage.setItem("jwtToken", responseData.token);
        sessionStorage.setItem("jwtToken", responseData.token);
        localStorage.setItem("usrName", responseData.name);
        localStorage.setItem("usrEmail", responseData.email);
        localStorage.setItem("usrCpf", responseData.cpf);
        
        // Salvar dados do certificado digital
        if (responseData.nm_thumbprint) {
          localStorage.setItem("nm_thumbprint", responseData.nm_thumbprint);
        }
        if (responseData.nm_thumbprint_sha256) {
          localStorage.setItem("nm_thumbprint_sha256", responseData.nm_thumbprint_sha256);
        }
        if (responseData.sg_tipo_documento) {
          localStorage.setItem("sg_tipo_documento", responseData.sg_tipo_documento);
        }
        if (responseData.nm_nr_documento) {
          localStorage.setItem("nm_nr_documento_cert", responseData.nm_nr_documento);
        }
        if (responseData.SSL_CLIENT_S_DN_CN) {
          localStorage.setItem("SSL_CLIENT_S_DN_CN", responseData.SSL_CLIENT_S_DN_CN);
        }
        if (responseData.nm_tipo_certificado) {
          localStorage.setItem("nm_tipo_certificado", responseData.nm_tipo_certificado);
        }
        if (responseData.SSL_CLIENT_S_DN) {
          localStorage.setItem("SSL_CLIENT_S_DN", responseData.SSL_CLIENT_S_DN);
        }
        if (responseData.SSL_CLIENT_V_START) {
          localStorage.setItem("SSL_CLIENT_V_START", responseData.SSL_CLIENT_V_START);
        }
        if (responseData.SSL_CLIENT_V_END) {
          localStorage.setItem("SSL_CLIENT_V_END", responseData.SSL_CLIENT_V_END);
        }
        
        // Configurar permissões de certificado
        localStorage.setItem("libProcuracao", 'true');
        localStorage.setItem("libAnuencia", 'true');

        // Se houver lógica de termo de uso
        if (responseData.ic_atualizacao_termo) {
          localStorage.setItem("tokenTermo", responseData.ic_atualizacao_termo);
        }

        this.$refs['modalLoading'].hide();
        this.loading = false;

        // Redirecionar baseado no tipo de login
        if (this.tipo_login === "solicitarCertidao") {
          this.$router.push({ name: "emolumentos" });
        } else if(this.pesquisa) {
          this.$refs['modalErroCert'].hide();
          this.$emit('loginpesquisa', { resposta: true });
        } else {
          if(responseData.ic_atualizacao_termo != 1) {
            this.$router.push('/termo-aceite-site');
          } else {
            this.$router.push({ name: "painel" });
          }
        }

      } catch (error) {
        this.$refs['modalLoading'].hide();
        this.loading = false;
        
        let msg = 'Erro no login com certificado digital';
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        } else if (error.message) {
          msg = error.message;
        }

        this.erroCertificadoDigital = true; // Marcar que o erro é do certificado digital
        this.erroCert = msg;
        this.$refs['modalErroCert'].show();
      }
    },

    async carregarWebPKI() {
      return new Promise((resolve, reject) => {
        // Verificar se já foi carregado
        if (typeof LacunaWebPKI !== 'undefined' && this.pki) {
          resolve();
          return;
        }

        // Criar script tag para carregar o Web PKI
        const script = document.createElement('script');
        script.src = 'https://cdn.lacunasoftware.com/libs/web-pki/lacuna-web-pki-2.14.0.min.js';
        script.onload = () => {
          if (typeof LacunaWebPKI !== 'undefined') {
            var licenca_lacuna = 'AusAYXBpLmNlbnByb3RuYWNpb25hbC5vcmcuYnIsYXBpLnBlc3F1aXNhcHJvdGVzdG8uY29tLmJyLGNhcnRvcmlvLmNlbnByb3RuYWNpb25hbC5vcmcuYnIsY2VucHJvdG5hY2lvbmFsLm9yZy5icixwa2kuY2FydG9yaW9zZGVwcm90ZXN0by5vcmcuYnIscGtpaG9tb2xvZ2EuY2FydG9yaW9zZGVwcm90ZXN0by5vcmcuYnIsc2l0ZS5jZW5wcm90bmFjaW9uYWwub3JnLmJyLHd3dy5wZXNxdWlzYXByb3Rlc3RvLmNvbS5icsoAaG1sLmFwaS5jZW5wcm90bmFjaW9uYWwuY29tLmJyLGlwNDoxMC4wLjAuMC84LGlwNDoxMC4wLjAuMC84LGlwNDoxMjcuMC4wLjAvOCxpcDQ6MTI3LjAuMC4wLzgsaXA0OjE3Mi4xNi4wLjAvMTIsaXA0OjE3Mi4xNi4wLjAvMTIsaXA0OjE5Mi4xNjguMC4wLzE2LGlwNDoxOTIuMTY4LjAuMC8xNixzaXRlLWhvbW9sb2cuY2VucHJvdG5hY2lvbmFsLm9yZy5icgMAUHJvAAAAAaovp0anSN3QSX7F/TNYIjbQsMqrqqW+74O01Do6s/PzKMvXwp1s9F8sthQztKRvws/+QL+PX3uBoMb1Rp5fKNOUemjxf6IkxUKJ+QRGFAciBZ0S3wSrueT66sOZM1Z15ylowRaPqz2BvyPIc3fmah7AaV0lpueG0X4suFZ+PGo1/tmHMzijcNqH0fndF6VgMyVYmTBhOH5l8mWWBfNonb+Ub/mMytkpBpLX/u2E2myej/emEy5YVO9fnFgQAlJLdDCB2dZDa7QS2XR0MYjPlIoiKfdfHmXhmAcv2halIVAbmkrByK8EQ3mHTKkA2vBdhCexFQtnXo7z4E9zpa8ixsg=';
            this.pki = new LacunaWebPKI(licenca_lacuna);
            resolve();
          } else {
            reject(new Error('LacunaWebPKI não foi carregado'));
          }
        };
        script.onerror = () => {
          reject(new Error('Erro ao carregar o Web PKI'));
        };
        
        document.head.appendChild(script);
      });
    },

    async inicializarPKI() {
      return new Promise((resolve, reject) => {
        if (!this.pki) {
          reject(new Error('PKI não foi inicializado'));
          return;
        }

        this.pki.init({
          ready: () => {
            resolve();
          },
          notInstalled: () => {
            reject(new Error('WebPKI não está instalado. Por favor, instale o componente WebPKI.'));
          },
          outdated: () => {
            reject(new Error('WebPKI está desatualizado. Por favor, atualize o componente WebPKI.'));
          }
        });
      });
    },
  },
  computed:{
    token2faString: function(){
      return this.token2fa.join('').toUpperCase(); 
    },
  },
  watch: {
    manterLogado (value){
      if(value) sessionStorage.setItem('keepAlive',value);
      else sessionStorage.removeItem('keepAlive');
    },
    'timer2fa.current': {
        handler(value) {
            if (value > 0) setTimeout(() => {this.timer2fa.current--;}, 1000);
        },
        immediate: true,
    }
  },
  created(){
    this.$root.isLogged().then((res) => {
      let logged = true;
      let govLogin = this.$root.isLoggedGov();
      if(govLogin){
        this.manterLogado = false;
        sessionStorage.removeItem('keepAlive');
      }
      else{
        let keepAlive = sessionStorage.getItem('keepAlive');
        this.manterLogado = (keepAlive && keepAlive != undefined);
      }
    }).catch((e) => {
      this.manterLogado = false;
      sessionStorage.removeItem('keepAlive');
    });
  }
}
</script>
<style scoped>

  @keyframes tremble {
    0%, 4%, 16%, 100% {
      transform: translateX(0);
    }
    5.5%, 8.5%, 11.5%, 14.5% {
      transform: translateX(-5px);
    }
    7%, 10%, 13%{
      transform: translateX(5px);
    }
  }
  h3{
    font-family: 'Kanit', sans-serif;
    font-size: 20px;
    font-weight: 200;
    letter-spacing: -1%;
    color: var(--secondary-color) !important;
    text-align: center;
  }
  .card-login-cadastro {
    padding:38px 76px 38px 74px;
  }
  .card-login-cadastro.bg-transparent {
    background: transparent;
  }
    .card-login-cadastro.bg-transparent .cardLogin{
      background: transparent;
    }
      .card-login-cadastro.bg-transparent .card-body input{
        background: #FFFFFF 0% 0% no-repeat padding-box;
      }
  .card-login-cadastro.bg-white {
    background: #FFFFFF 0% 0% no-repeat padding-box;
  }
    .card-login-cadastro.bg-white .cardLogin{
      background: #FFFFFF 0% 0% no-repeat padding-box;
    }
      .card-login-cadastro.bg-white .card-body input{
        background: #DCE2E6 0% 0% no-repeat padding-box;
      }
  .card-login-cadastro.border-blue {
    box-shadow: 4px 4px 50px 0 #D1DBE2;
    border-radius: 42px;
  }
  .card-login-cadastro.border-smooth {
    box-shadow: 4px 6px 20px -3px #00000063;
    border-radius: 7px;
  }
  .cardLogin{
    margin: 0 !important;
  }
  .cardLogin .col{
    padding: 0;
  }
  .cardLogin .form-group{
    margin-bottom: 0;
  }
  .cardLogin label {text-align:left;}
  .cardLogin button.btn-lg{
    border-radius: 42px;
    height: 49px;
    background: var(--primary-color) 0% 0% no-repeat padding-box !important;
    border: none !important;
    text-align: center;
    font-family: 'Kanit', sans-serif;
    font-size: 20px;
    font-weight: 400;
    letter-spacing: -1%;
    margin: 0 auto;
    margin-bottom: 16px !important;
    width: 247px;
  }
  .cardLogin .politica-privacidade-container span a{    
    color: var(--primary-color);
    font-weight: 400;
  }
  .cardLogin .politica-privacidade-container span{
    text-align: center;
    font: normal normal normal 15px/20px 'Kanit', sans-serif;
    letter-spacing: 0px;
    color: #A8A8A8;
  }
  .cardLogin .btn-cadastro-container{
    display: flex;
    flex-flow: column;
    width: 303px;
    justify-content: center;
  }
  .cardLogin .btn-cadastro-container span{
    font-family: 'Kanit', sans-serif;
    font-size: 15px;
    font-weight: 200;
    letter-spacing: -1%;
    color: var(--secondary-color);
    margin-bottom: 13px;
    text-align: center;
  }
  .cardLogin button.btnCadastro {
    background: var(--dark-gray-color) 0% 0% no-repeat padding-box;
    border-radius: 42px;
    height: 49px;
    border:none;
    text-align: center;
    font-family: 'Kanit', sans-serif;
    font-size: 20px;
    font-weight: 400;
    letter-spacing: -1%;
    color: #FFFFFF;
    max-width: 177px;
    width: fit-content;
    margin: 0 auto;
    margin-bottom: 24px;
  }
  .cardLogin .esqueci-senha-container{
    margin-bottom: 24px !important;
  }
  .cardLogin a.link{
    text-decoration: underline;
    font-family: 'Kanit', sans-serif;
    font-size: 15px;
    font-weight: 400;
    letter-spacing: -1%;
    color: var(--secondary-color);
  }
  .card-body{
    padding: 0;
    background-color: transparent;
  }
  .card-body label{
    width: inherit;
    font-family: 'Kanit', sans-serif;
    font-size: 15px;
    font-weight: 200;
    letter-spacing: -1%;
    color: var(--secondary-color);
    margin-bottom: 10px;
    margin-left: 22px;
  }
  .card-body input:focus{
    box-shadow: none;
  }
  .card-body input::placeholder{
    color: #A8A8A8;
  }
  .card-body input{
    border: 1px solid #FFFFFF;
    border-radius: 40px !important;
    text-align: left;
    font-family: 'Kanit', sans-serif;
    font-size: 20px;
    font-weight: 200;
    letter-spacing: -1%;
    color: var(--secondary-color);
    text-transform: none;
    width: 303px;
    height: 44px;
    margin-bottom: 13px;
    padding-left: 20px;
  }
  .card{
    margin: 0 !important;
    -webkit-tap-highlight-color: unset;
    border: unset;
    box-shadow: none !important;
  }
  .card-title.blueE{
    font-family: 'Kanit', sans-serif;
    font-size: 24px;
    font-weight: 200;
    letter-spacing: -1%;
    color: var(--secondary-color);
    text-transform: none;
    text-align: center;
  }
  .blueE {
      color: #004E86;
      font-size: 30px;
  }
  @media (min-width: 360px) and (max-width:800px) {
      img {
      max-width: 180px !important;
      }

      .card-title {
      font-size: 24px !important;
      }
  }
  .certificadoDigital{
    box-shadow: 0px 2px 11px -2px rgb(0 0 0 / 40%);
    border-radius: 8px;
    padding: 16.5px 31.5px;
    width: fit-content;
    margin: auto;
    background-color: white;
    margin-bottom: 21px;
  }
  .certificadoDigital span{
    font-family: 'Kanit';
    font-size: 11px;
    font-weight: lighter;
    margin-left: 10px;
  }

  .br-sign-in:hover{
    background-color: #D3DDED;
  }
  .br-sign-in{
    font-family: 'Kanit', sans-serif;
    align-items: center;
    display: flex;
    text-align: center;
    background: white;
    border-radius: 50px;
    border:none;
    height: 50px;
    padding: 0 18px;
    font-size: 16px;
    font-weight: 400;
    color: var(--secondary-color);
    margin: auto;
    box-shadow: 0px 0px 13px -6px black;
  }
  .br-sign-in img{
    margin-left: 2px;
    height: 22px;
  }
  .card-title.acesseTambem{
    margin: 20px auto 15px auto;
  }
  .card-title.ou {
    background: rgb(16,90,178);
    background: linear-gradient(130deg, rgba(16,90,178,1) 0%, rgba(4,135,165,1) 60%);
    border-radius: 100%;
    color: white;
    height: 45px;
    width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 15px;
  }
  .card-login-alternativo{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cardLogin{
    width: fit-content;
    margin: auto;
  }
  .hide-pwd {
    position: absolute;
    right: 12px;
    top: 11px;
    width: 23px;
    height: auto;
    color: #555;
    cursor: pointer;
  }
  .hide-pwd:hover{
    color: #597EB5;
  }
  .hide-pwd.slash {
    width: 25px;
    right: 8px;
  }
  @media (max-width: 540px){
    .card-login-cadastro{
      max-width:calc(100vw - 34px);
    }
    .card-login-cadastro .card.cardLogin{
      max-width:100%;
    }
    .card-login-cadastro .certificadoDigital{
      padding: 13.5px 7.5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }


/* Token verificador login */
.card-body .token-login-container {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  max-width: 303px;
}
.card-body .token-login-container .token-login-input-container{
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-body .token-login-container .token-login-input-container input.token-login-input {
  background: transparent;
  border: 1px solid #c3c3c3;
  width: 30px;
  height: 48px;
  text-transform: uppercase;
  text-align: center;
  vertical-align: middle;
  font-family: 'Kanit', sans-serif;
  font-size: 20px;
  font-weight: 200;
  letter-spacing: -1%;
  color: #495057;
  margin-bottom: 0px;
  padding-left: 3px;
}
.card-body .token-login-container .token-login-input-container input.token-login-input:focus,
.card-body .token-login-container .token-login-input-container input.token-login-input:focus-visible{
  border-color: #4780F1 !important;
  border-width: 2px !important;
	outline: none !important;
}
.card-body .token-login-container .token-login-input-container input.token-login-input:focus::placeholder,
.card-body .token-login-container .token-login-input-container input.token-login-input:focus-visible::placeholder{
  color: transparent;
}

.card-body .token-login-container .token-login-input-container:nth-child(4)::after {
  content: '';
  width: 9px;
  height: 2px;
  background: #c3c3c3;
  margin: 0px 5px 0px 10px;
}
.card-body p{
  font:'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  color: #707070;
  width: 300px;
  margin: 0 auto;
  text-align: center;
}
.token-login-container p{
  margin-top: 20px;
  text-align: left;
  /* margin-left: 38px; */
}
.btn:disabled{
  cursor: not-allowed;
}

.card-body .token-login-container.login-danger p.label-token{
  color: #1ACEB5;
  margin-left: 38px;
}
.token-login-container.login-danger  .token-login-input-container input.token-login-input{
  border: 1px solid #1ACEB5;
  color: #1ACEB5;
  animation: tremble 5s ease-in-out 3;
}
p.token-error-msg{
  color: #1ACEB5;
  font-weight: bold;
  margin: 0px;
  text-align: center;
  width:100%;
}
.card-body .token-login-container.login-danger .token-login-input-container:nth-child(4)::after {
  background-color: #1ACEB5;
}
.card-token-option-selection{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #597EB5;
  cursor: pointer;
  margin-bottom: 15px;
  border-radius: 8px;
  height: 120px;
  width: 380px;
  padding: 15px;
}
.card-token-option-selection:hover{
  box-shadow: 3px 3px 10px #00000052;
}
.card-token-option-selection input{
  width: 25px;
  height: 25px;
  margin: 0px;
}
.card-token-option-selection .text-card{
  width: 220px;
  text-align: center;
  margin: 0px 15px;
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
}
.problema-token{
  width: 380px;
}
button.problema-token-btn{
  width: 380px !important;
}
.voltar-step-login{
  display: flex;
  align-items: center;
  font-family: 'Kanit', sans-serif;
  font-size: 16px;
  font-weight: 200;
  letter-spacing: -1%;
  color: var(--secondary-color);
  margin-bottom: 10px;
  cursor: pointer;
  width: fit-content;
  position: relative;
  margin-right: auto;
}
.voltar-step-login::before{
  content:'';
  display: flex;
  width: 10px;
  height: 10px;
  border-left: 2px solid var(--secondary-color);
  border-top: 2px solid var(--secondary-color);
  transform: rotate(-45deg);
  margin-right: 15px;
  transition: all 0.15s ease-in;
}
.voltar-step-login::after{
  content:'';
  display: flex;
  width: 15px;
  height: 2px;
  background-color: var(--secondary-color);
  position: absolute;
  top: 11px;
  left: 1px;
  transition: all 0.15s ease-in;
}
.voltar-step-login:hover::after{
  transform: translateX(-8px);
}
.voltar-step-login:hover::before{
  transform: rotate(-45deg) translateY(-6px) translateX(-6px);
}

@media (max-width: 540px){
    .problema-token,
    button.problema-token-btn,
    .card-token-option-selection{
      max-width: calc(100vw - 34px - 20px);
    }
    .card-token-option-selection .text-card{
      margin: 0 5px;
      font-size: 13px;
      width: 190px;
    }
    .card-token-option-selection img {
      width: 20px !important;
      height: 20px !important;
    }
    .card-token-option-selection h3{
      font-size:15px;
    }
    .card-body .token-login-container .token-login-input-container input.token-login-input{
      width: 34px;
      height: 54.4px;
      font-size: 15px;
    }
    .card-body p{
      width:100%;
    }
  }
  .manter-logado-container {
    transition: all 0.3s ease;
    align-items:center;
    justify-content: flex-end;
    height: 49px;
    cursor:pointer;
    user-select: none;
    border: 1px solid var(--primary-color);
    background: #fff;
    border-radius: 42px;
  }
  .manter-logado-container:hover,
  .manter-logado-container.selected{
    background: var(--primary-color);
  }
  .manter-logado-container span{
    transition: all 0.3s ease;
    text-align: center;
    font-family: 'Kanit', sans-serif;
    font-size: 20px;
    font-weight: 400;
    letter-spacing: -1%;
    color: var(--primary-color);
    width: 100%;
  }
  .manter-logado-container:hover span,
  .manter-logado-container.selected span{
    color: #fff;
  }
  .manter-logado-container .manter-logado-selection{
    margin-top: -4px;
  }
  </style>